import ManageParameters from './ManageParameters';
export default ManageParameters;